import { createClient } from '@supabase/supabase-js';

import { appConfig } from 'src/app/app-config';

if (!appConfig.supabase.anonKey || !appConfig.supabase.url)
    throw new Error('Supabase URL and anon key are required.');

export const supabaseClient = createClient(appConfig.supabase.url, appConfig.supabase.anonKey, {
    auth: { persistSession: false },
});
